import es from './es'
import en from './en'
import pt from './pt'

const TRANSLATIONS = {
  es,
  en,
  pt,
}

export default TRANSLATIONS
